<template>
  <div v-show="visible">
    <div class="popup_wrap version_history">
      <div class="popup_title">
        <p><span id="node_title">버전이력
        </span></p>
        <a class="_command[CmmComm.closeLayer]">
          <div id="popup_close" class="btn_close" title="Close" @click="close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div class="node_order_wrap">
          <div class="node_order_box_middle">

            <h4 class="node_order_tit">버전이력목록</h4>
<!--            <div class="node_order_con">※ 미입력된 항목은 붉은색으로 표시됩니다.</div>-->
            <ul class="kind_list">
                <li v-for="(history,idx) in historyList"
                  :class="{ 'on' : selectedLogId == history.experimentLogId }" :key="idx">
                <a @click="selectLog(history.experimentLogId)">{{(idx+1)+". "+history.userName}} [{{history.createDate}}]</a>
                </li>
<!--                <li class="on"><a href="">4.테스트공정</a></li>
              <li class="nothing"><a href="">5.골드</a></li>-->
            </ul>
          </div>
          <div class="node_order_box_right" style="flex: 3; background-color: white">
            <hot-table v-show="this.cellsFromDB.length > 0"
                ref="versionHandsonRef"
                :settings="hotSettings"
                :key="hotKey"
                :licenseKey="'6c578-61cf1-e8cf5-b453c-1f850'"/>
            <div v-show="this.cellsFromDB.length == 0">
              <div class="nodata_txt"><p>버전을 선택해 주세요.</p></div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup_footer">
        <a class="btn_type1" @click="revertData">버전되돌리기</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import {createNamespacedHelpers} from 'vuex';
import {HotTable} from "@handsontable/vue";
import {
  groupBy,
  settingHeader,
  colWidthArray,
  checkActiveRow,
  generateUniqueID,
  DEFAULT_COL_INDEX,
  COL_PREFIX,
} from "@/util/HubHandsonTable";
const Hub = createNamespacedHelpers('Hub');
const ProcessEditor = createNamespacedHelpers('ProcessEditor');

export default {
  components: {
    Loading,
    HotTable
  },
  data() {
    return {
      loading : null,
      visible : false,
      historyList : null,
      selectedLogId : null,
      cellsFromDB: [], // 셀 데이터
      changeStack : [], //변경사항 Cell
      hotKey : 0,
      hotInstance : null,
      hotSettings: {
        width: '100%',
        height: '100%',
        autoWrapRow: true,
        autoWrapCol: true,
        rowHeaders: true,
        colHeaders: true,
        autoColumnSize : false,
        afterOnCellMouseDown: (event, coords) => {
          const row = coords.row;
          const col = coords.col
          if (row < 0 && col >= 0) {
            // 해당 열의 메타정보를 가져옵니다.
            const colMeta = this.hotInstance.getColHeader(col);
            const columnInfo = this.hotInstance.getSettings().columns[col];
            console.log(`========================================`);
            console.log(`Selected Header [Column ${col}] - Header Label:`, colMeta,` || Column Meta:`, columnInfo);
            console.log(`========================================`);
          } else if(col < 0 && row >= 0){
            // 해당 row의 메타정보를 가져옵니다.
            const rowLabel = this.hotInstance.getRowHeader(row);
            console.log(`#####################`);
            console.log(`Selected Header [Row ${row}] - Header Label:`, rowLabel);
            console.log(`####################`);
          }else if (row >= 0 && col >= 0) {
            // 선택한 셀의 컬럼데이터
            const columnInfo = this.hotInstance.getSettings().columns[col];
            // 선택한 셀의 데이터
            const cellData = this.hotInstance.getDataAtCell(row, col);
            // 선택한 셀의 메타데이터
            const cellMeta = this.hotInstance.getCellMeta(row, col);

            console.log(`**********************`);
            console.log(`Selected cell [${row}, ${col}] - Data:`, cellData, ` || Meta:`, cellMeta);
            console.log(`**********************`);
          }
        },
      }
    }
  },
  computed : {
    ...Hub.mapGetters(
        [
            'getVersionHistoryPopFlag','getSelectedReleaseProcess'
      ]),
  } ,
  watch: {
    changeStack: {
      deep: true,
      async handler(value) {
        //console.log('changeStack =',value)
      }
    },
    getVersionHistoryPopFlag: {
      async handler (value) {
        if(value === true){
          this.show();
          await this.initialize();
        }else{
          this.visible = false;
          this.selectedLogId = null;
          this.cellsFromDB = [];
          this.historyList = [];
          this.changeStack = [];
          this.hotKey++;
        }
      }
    },
    /*getExperimentTypeSaveFlag: {
      deep: true,
      // immediate: true,
      async handler (value) {
        //console.log('[ExperimentType.vue]getExperimentTypeSaveFlag = ',value);
        Object.assign(this.input, {
            experimentName: this.getExperimentTypeSaveFlag == 'create'? "신규 기본값SET" : this.getSelectedExperiment.experimentName,
            experimentType: this.getExperimentTypeSaveFlag == 'create'? "SHARE" : this.getSelectedExperiment.experimentType
        });
      }
    },
    getProcessPropertyListOfExperiment: {
      deep: true,
      // immediate: true,
      async handler (value) {
        //깊은복사
        this.experimentTypeAttribute = JSON.parse(JSON.stringify(this.getProcessPropertyListOfExperiment));
      }
    },*/
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        ['setVersionHistoryPopFlag']
    ),
    async initialize(){
      try {
        //header세팅
        const {nestedHeaders, columns} = await settingHeader(
            this.$wApi,
            this.$route,
            this.getSelectedReleaseProcess
        );

        this.hotSettings.nestedHeaders = nestedHeaders;
        this.hotSettings.columns = columns;

        // hotInstance는 hot-table 컴포넌트가 렌더된 이후에 접근 가능
        this.$nextTick(() => {
          this.hotInstance = this.$refs.versionHandsonRef.hotInstance;
          this.hotInstance.updateSettings({
            readOnly: true,
            nestedHeaders: nestedHeaders,
            columns: columns,
            hiddenColumns: {
              columns: [0, 1], // 숨길 컬럼의 인덱스
              indicators: false, // 숨긴 열의 표시기(true) 또는 숨기기(false)
            },
            colWidths: colWidthArray,
            afterGetColHeader: (col, TH) => {
              // 컬럼별로 헤더 배경색 설정
              // 컬럼 색상 설정
              if (columns[col] && columns[col].tagType) {
                switch (columns[col].tagType) {
                  case "PROCESS":
                    TH.style.backgroundColor = '#D8E5F5';
                    break;
                  case "MATERIAL":
                    TH.style.backgroundColor = '#E2DDE9';
                    break;
                  case "EQUIPMENT":
                    TH.style.backgroundColor = '#DAEDE8';
                    break;
                }
              }
            },
          });
        });

        const res = await this.$wApi.experiment.history.getVersionList({
          processId : this.$route.query.processId
        });

        if(!res.error){
          this.historyList = res;
        }else{
          alert(`${res.message}`);
        }
      }catch (e){
        console.log(e);
      }
    },
    async selectLog(logId) {
      try {
        this.selectedLogId = logId;
        this.cellsFromDB = [];
        this.changeStack = [];
        const res = await this.$wApi.experiment.history.getVersionHistoryData({
          processId: this.$route.query.processId,
          logId: logId
        });

        if (!res.error) {
          this.cellsFromDB = res;
          this.hotInstance.updateSettings({
            data: this.buildRowData(this.cellsFromDB, this.hotSettings.columns),
          });
          // 데이터 로드 후 메타데이터 적용!. 처음 세팅시에만 활용함.
          //this.applyCellMetadata(this.hotInstance);
          this.hotInstance.render();
        } else {
          alert(`${res.message}`);
        }

        const {nestedHeaders, columns} = await settingHeader(
            this.$wApi,
            this.$route,
            this.getSelectedReleaseProcess
        );

        this.hotSettings.nestedHeaders = nestedHeaders;
        this.hotSettings.columns = columns;

        // hotInstance는 hot-table 컴포넌트가 렌더된 이후에 접근 가능
        this.$nextTick(() => {
          this.hotInstance.updateSettings({
            readOnly: true,
            nestedHeaders: nestedHeaders,
            columns: columns,
            hiddenColumns: {
              columns: [0, 1], // 숨길 컬럼의 인덱스
              indicators: false, // 숨긴 열의 표시기(true) 또는 숨기기(false)
            },
            colWidths: colWidthArray,
            afterGetColHeader: (col, TH) => {
              // 컬럼별로 헤더 배경색 설정
              // 컬럼 색상 설정
              if (columns[col] && columns[col].tagType) {
                switch (columns[col].tagType) {
                  case "PROCESS":
                    TH.style.backgroundColor = '#D8E5F5';
                    break;
                  case "MATERIAL":
                    TH.style.backgroundColor = '#E2DDE9';
                    break;
                  case "EQUIPMENT":
                    TH.style.backgroundColor = '#DAEDE8';
                    break;
                }
              }
            },
          });
        });
      } catch (e) {
        console.log(e);
      }
    },
    buildRowData(cellsFromDB, columns) {
      //1. celldata 그룹화 및 row order 기준 정렬. [[key,value],[key,value]]구조
      const cellGroupByRowId = groupBy(cellsFromDB,"rowId").sort((a,b) => a[1][0].rowOrder - b[1][0].rowOrder);
      //console.log("[VersionHistory] cellGroupByRowId not exclusive",JSON.parse(JSON.stringify(cellGroupByRowId)));

      //2.column에 매핑되는 cell 관련 제어(재공개시 없던 신규속성이 추가된경우 or 재공개시 있던 값이 사라진경우)
      const columnOrder = columns.map(col => col.data);
      cellGroupByRowId.forEach(row => {
        const rowId = row[0];
        const cellItemArr = row[1];
        const experimentId = cellItemArr[0].experimentId;
        const processId = cellItemArr[0].processId;
        //1. 재공개시 없던 신규속성이 추가된경우 추가
        columns.filter(col => col.processPropertyType != 'HIDDEN').forEach(col => {
          const found = cellItemArr.some((cell) => COL_PREFIX+cell.processPropertyId === col.data);
          if(!found){
            cellItemArr.push({
              processPropertyId: col.data.replace(COL_PREFIX, ''),
              rowId: rowId,
              processId: processId,
              experimentId: experimentId,
              value: '',
              changeFlag : true //없던 속성이 생겼을 경우 값을 만들어줌. changeStack 추가 시 사용하는 플래그.
            })
          }
        });

        //2. 재공개시 있던 속성이 제거된경우 cell 제거
        for (let i = cellItemArr.length - 1; i >= 0; i--) {
          const cell = cellItemArr[i];
          const found = columns.filter(col => col.processPropertyType != 'HIDDEN').some((col) => col.data === COL_PREFIX+cell.processPropertyId);

          // column 배열에 없는 processPropertyId를 가진 cell은 제거
          if (!found) {
            cellItemArr.splice(i, 1);
          }
        }
        //3. row별 cell정렬
        cellItemArr.sort((a, b) => {
            return columnOrder.indexOf(COL_PREFIX+a.processPropertyId)
              - columnOrder.indexOf(COL_PREFIX+b.processPropertyId);
        });

        //4. 변경사항이 있는 Cell인 경우 변경 스택에 쌓기.
        cellItemArr.filter(cell => cell.changeFlag).forEach(cell => {
          this.addChangeStack(experimentId,rowId,cell.processPropertyId,cell.value,cell.mappingIdList);
        });
      });
      //console.log("[VersionHistory] cellGroupByRowId",cellGroupByRowId);

      const handsonTableData = {};
      cellGroupByRowId.forEach(rowInfo => {
        //console.log('rowInfo',rowInfo);
        if (!handsonTableData[rowInfo[0]]) {
          handsonTableData[rowInfo[0]]= {}; // 새로운 행을 생성
        }
        rowInfo[1].forEach((cell,index) => {
          if(index == 0){
            handsonTableData[rowInfo[0]][COL_PREFIX+'rowId'] = rowInfo[0];
            handsonTableData[rowInfo[0]][COL_PREFIX+'experimentId'] = cell.experimentId;
          }
          handsonTableData[rowInfo[0]][COL_PREFIX+cell.processPropertyId] = cell.value;
        })
      });
      //console.log('[VersionHistory] buildRowData',Object.values(handsonTableData))
      return Object.values(handsonTableData);
    },
    addChangeStack(experimentId, rowId, processPropertyId, newValue, mappingFileIdList) {
      if (processPropertyId == 'rowId' || processPropertyId == 'experimentId') return; //숨김컬럼은 데이터 매핑용도
      this.changeStack.push({
        rowId: rowId
        , processPropertyId: processPropertyId
        , value: newValue
        , experimentId: experimentId
        , mappingFileIdList : mappingFileIdList
      });
    },
    async revertData() {
      try {
        const flag = await confirm("현재 선택한 버전으로 되돌리시겠습니까?");
        if(!flag) return;
        this.loading = true;
        const saveRes = await this.$wApi.experiment.saveExperimentData({
          activeRowList : checkActiveRow(this.hotInstance),
          processId : this.$route.query.processId,
          experimentLogFlag : "REVERT",
          releaseExperimentDataList : this.changeStack,
          logMemo : "버전되돌리기",
        });

        if(!saveRes.error){
          location.reload();
        }else{
          alert("Error! " + saveRes.message);
          this.close();
        }
      } catch (e) {
        console.log('saveData Error!!', e)
      } finally {
        this.loading = false;
      }
    },
    show() {
      this.visible = true;
    },
    close() {
      this.setVersionHistoryPopFlag(false);
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";
.version_history  {display:block;position:fixed; width:1200px;height:85%;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:999; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}

@media screen and (max-width: 950px) {
  .version_history {width:95%;}
}

</style>
